// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import ITTObjectSchema from './itt-object-schema';

const schema = {
  $id: '/lecture-lesson-lecturer-schema',
  type: 'object',
  required: ['id'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    lecturerId: {
      type: 'integer',
      nullable: true,
    },
    lecturerRoleId: {
      type: 'integer',
      nullable: true,
    },
    lecturerRoleName: {
      type: 'string',
      nullable: true,
    },
    lecturerFirstName: {
      type: 'string',
      nullable: true,
    },
    lecturerLastName: {
      type: 'string',
      nullable: true,
    },
    lecturerFullName: {
      type: 'string',
      nullable: true,
    },
    lecturerStatusName: {
      type: 'string',
      nullable: true,
    },
    lecturerComment: {
      type: 'string',
      nullable: true,
    },
    ttComment: {
      ...ITTObjectSchema,
    },
    lecturerAdminComment: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
